import React from 'react';

export const SubmitButton = ({ isSubmit, label, className }) => {
    return (
        <>
            <button type='submit'
                disabled={isSubmit}
                className={`${!isSubmit
                    ? "text-black bg-main"
                    : "text-gray-400 bg-slate-200 "
                    } ${className ?? 'btn flex items-center justify-center w-full lg:w-6/12 my-3'} `}
            >
                {isSubmit ? (
                    <span className="loading loading-spinner loading-xs mx-2"></span>
                ) : null}
                {" "}
                {!isSubmit ? label : <p className='text-sm'>Veuillez patientez...</p>}
            </button>
        </>
    )
}
